import { AlertTriangle, Home, RefreshCcw } from "lucide-react";
import { useNavigate } from "react-router-dom";

const NotFoundPage = () => {
  const navigate = useNavigate();

  const logo = require("../assets/images/logo.png");

  const handleGoHome = () => {
    navigate("/");
  };

  const handleReload = () => {
    window.location.reload();
  };

  return (
    <div className="h-screen flex items-center justify-center bg-gradient-to-tr from-[#0F0068] to-[#9747FF]">
      <div className="max-w-md w-full bg-white rounded-2xl shadow-xl overflow-hidden text-center relative">
        <div className="bg-red-50 p-6 flex justify-center">
          <div className="bg-red-100 p-4 rounded-full">
            <AlertTriangle size={48} className="text-red-500" />
          </div>
        </div>

        <div className="p-8">
          <img src={logo} alt="Logo" className="h-8 mx-auto mb-6 opacity-80" />

          <h1 className="text-2xl font-bold text-gray-900 mb-2">
            Something went wrong
          </h1>

          <p className="text-gray-500 mb-8">
            We encountered an unexpected error. Our team has been notified.
            Please try reloading the page or return home.
          </p>

          <div className="space-y-3">
            <button
              onClick={handleReload}
              className="w-full flex items-center justify-center gap-2 px-6 py-3 bg-gray-900 text-white rounded-lg font-medium hover:bg-gray-800 transition-colors focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-900"
            >
              <RefreshCcw size={18} />
              Reload Page
            </button>

            <button
              onClick={handleGoHome}
              className="w-full flex items-center justify-center gap-2 px-6 py-3 bg-white border border-gray-200 text-gray-700 rounded-lg font-medium hover:bg-gray-50 transition-colors focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-200"
            >
              <Home size={18} />
              Return to Home
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NotFoundPage;
